// Safe link rendering for chat text: split into [{ link, value }] parts (templates render each part as its own
// node, no v-html). A URL whose host is a bare IP address renders as plain text.
const URL_RE = /(https?:\/\/[^\s<>"')\]]+)/g;
const LINK_RE = /^https?:\/\/[^\s<>"')\]]+$/;
const RAW_IP_HOST_RE = /^https?:\/\/(?:\d{1,3}(?:\.\d{1,3}){3}|\[[0-9a-f:.]+\])(?::\d+)?(?:[/?#]|$)/i;
export function isRawIpUrl(part) { return RAW_IP_HOST_RE.test(String(part ?? "")); }
export function splitLinks(text) {
  const value = String(text ?? "");
  if (!value) return [];
  return value.split(URL_RE).filter((part) => part !== "").map((part) => ({ link: LINK_RE.test(part) && !isRawIpUrl(part), value: part }));
}
